// establishment.store.ts
import { createEntityStore } from "@/core/factory/store"
import { createEmptyEstablishment, Establishment, ESTABLISHMENT_ENTITY } from "./establishment.types"
import { noContext } from "@/core/utils/noContext"

export const createEstablishmentStore = () => {
  const base = createEntityStore<Establishment, null>(ESTABLISHMENT_ENTITY, createEmptyEstablishment, noContext)

  return {
    ...base,
    actions: {
      ...base.actions
    },
    selectors: {
      ...base.selectors
    },
    thunks: {
      ...base.thunks
    }
  }
}

const establishmentStore = createEstablishmentStore()
export default establishmentStore
